import useScreenSize from "../../../../hooks/useScreenSize";
import AddButton from "./components/AddButton";
import ScreenOptions from "./components/ScreenOptions";
import SearchField from "./components/SearchField";
import FilterTopBar from "./components/FilterTopBar";

function Header() {
  const screenSize = useScreenSize();
  const isLarge = screenSize === "xl" || screenSize === "2xl";

  return (
    <div className="w-full bg-white px-2 sm:px-4 lg:px-5 py-3 overflow-hidden">
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 w-full">
          <div className="flex flex-col lg:flex-row items-center gap-3 w-full xl:w-auto">
            <div className="w-full sm:flex-1 lg:min-w-[280px]">
              <SearchField />
            </div>

            <div className="flex sm:flex-row flex-col items-center justify-between sm:justify-start gap-2 sm:gap-3 w-full sm:w-auto">
              <FilterTopBar />
              <AddButton />
            </div>
          </div>

          {isLarge && (
            <div className="flex justify-start lg:justify-end w-full lg:w-auto">
              <ScreenOptions />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
